<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import type { WorkOrderAssignmentRow } from "../../contract"
  import RequesterContactCell from "./_modules/requester-contact-cell"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
</script>

<RequesterContactCell {row} />
